module.exports = __webpack_public_path__ + "static/media/cheese.5d44ac70.svg";